import { T, ParamsTags } from '@tolgee/react';
import { AttributesAliases } from 'src/generated/dict.ts';
import { ATTRIBUTE_NS } from 'src/bootstrap/constants.ts';
import type { TranslateParams } from '@tolgee/web';

export type I18nProps = {
    messageId: string;
    params?: TranslateParams<ParamsTags>;
}

const AttributeIDs = Object.values(AttributesAliases);

export const I18n = (
    { messageId, params }: I18nProps,
) => {
    const namespace = AttributeIDs.includes(messageId) ? ATTRIBUTE_NS : undefined;
    // return (<><T keyName={messageId} ns={namespace} defaultValue={messageId}/>{messageId}</>);
    return (
        <T
            keyName={messageId}
            ns={namespace}
            defaultValue={messageId}
            params={params}
        />
    );
};
